import { FETCH_BUSSINESS_TYPES_SUCCESS, FETCH_BUSINESS_TYPES_ERROR } from '../constants';
import { Action, BusinessType, ListOfPds } from '../types';
import { BusinessTypes } from '../types';

const initialState: BusinessTypes = {
  hasError: false,
  businessTypes: [],
};

const businessTypes = (state = initialState, action: Action) => {
  switch (action.type) {
    case FETCH_BUSSINESS_TYPES_SUCCESS:
      return { ...state, businessTypes: action.data as ListOfPds[] };
    case FETCH_BUSINESS_TYPES_ERROR:
      return { ...state, hasError: action.data as boolean };
    default:
      return state;
  }
};

export default businessTypes;
